const _require = require('../lib/mergePatch'),
  generateMergePatch = _require.generateMergePatch;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate jsonDiffBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const from = await evaluateSource(source.from, content, parentContentPath, transientContext, nativeFunctions);
  const to = await evaluateSource(source.to, content, parentContentPath, transientContext, nativeFunctions);
  if (from === undefined && to === undefined) {
    return {};
  }
  if (from === undefined) {
    return to;
  }
  if (to === undefined) {
    return null;
  }
  return generateMergePatch(from, to);
};
module.exports = {
  evaluate
};